import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './PromoteTabs.css';

const PROMOTE_TABS = [
  {
    key: 'company',
    label: 'Empresa',
    href: '/dashboard?section=promocionar&target=company',
    isActive: location => {
      if (location.pathname !== '/dashboard') return false;
      const params = new URLSearchParams(location.search);
      const section = params.get('section');
      const target = params.get('target') || 'company';
      return section === 'promocionar' && target === 'company';
    },
  },
  {
    key: 'publications',
    label: 'Publicaciones',
    href: '/dashboard?section=promocionar&target=publications',
    isActive: location => {
      if (location.pathname !== '/dashboard') return false;
      const params = new URLSearchParams(location.search);
      return params.get('section') === 'promocionar' && params.get('target') === 'publications';
    },
  },
  {
    key: 'credits',
    label: 'Recargar créditos',
    href: '/checkout/credits',
    isActive: location => location.pathname.startsWith('/checkout/credits'),
  },
  {
    key: 'membership',
    label: 'Membresía Flotte',
    href: '/dashboard?section=suscripciones',
    isActive: location => {
      if (location.pathname !== '/dashboard') return false;
      const params = new URLSearchParams(location.search);
      return params.get('section') === 'suscripciones';
    },
  },
];

const PromoteTabs = () => {
  const location = useLocation();

  const tabs = useMemo(
    () =>
      PROMOTE_TABS.map(tab => ({
        ...tab,
        active: tab.isActive(location),
      })),
    [location]
  );

  return (
    <nav className="promote-tabs" aria-label="Opciones para promocionar">
      <div className="promote-tabs__container">
        {tabs.map(tab => (
          <Link
            key={tab.key}
            to={tab.href}
            className={`promote-tabs__item${tab.active ? ' is-active' : ''}`}
            aria-current={tab.active ? 'page' : undefined}
          >
            {tab.label}
          </Link>
        ))}
      </div>
    </nav>
  );
};

export default PromoteTabs;
